export default __webpack_public_path__ + "static/media/gmail.bdd58fc4.svg";